import { Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import SuggestionItems from './SuggestionItems';
import type { TripData } from 'types/production.types';
import MultiColorCircularLoader from '../BoxLoader/MultiColorCircularLoader';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

interface Props {
  enableDarkTheme: boolean;
  minHeight: string;
  data: TripData[];
  isLoading: boolean;
  startDate: string;
  isSelected: string;
  setSuggestionData: any;
}

const Suggestions = ({
  enableDarkTheme,
  minHeight,
  data,
  isLoading,
  startDate,
  isSelected,
  setSuggestionData,
}: Props) => {
  const { t } = useTranslation();
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  return (
    <Grid item lg={3} md={6} sm={12}>
      <Box
        sx={{
          padding: 2,
          backgroundColor: enableDarkTheme
            ? palette.boxBackground
            : palette.toolBarBackground,
          borderRadius: '5px',
          border: `1px solid ${palette.cardBorderColor}`,
          minHeight,
          maxHeight: '300px', // Fixed height for the list
          overflowY: 'auto', // Enable vertical scrolling
        }}
      >
        {/* <Typography
          sx={{
            fontSize: '13px',
            fontWeight: '600',
          }}
        >
          Suggestions
        </Typography> */}
        <Box
        // sx={{
        //   paddingTop: '10px',
        // }}
        >
          {isLoading ? (
            <MultiColorCircularLoader height="300px" />
          ) : data?.length > 0 ? (
            <SuggestionItems
              enableDarkTheme={enableDarkTheme}
              data={data[0]}
              setSuggestionData={setSuggestionData}
            />
          ) : (
            <Typography sx={{ fontSize: '10px', fontWeight: 'normal' }}>
              {t('no_data_available_currently')}
            </Typography>
          )}
        </Box>
      </Box>
    </Grid>
  );
};

export default Suggestions;
